import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-h5" }

import FormCombobox from '@/components/FormCombobox.vue';

	import { defineComponent, PropType } from 'vue';
	import { IServerData } from '@/interfaces/Search';
	import { IEditable, IEntity } from '@/interfaces/Data';
	import { Alert, AlertType } from '@/interfaces/Notification';
	import { ApplicationService } from '@/services/ApplicationService';
	import { FormService } from '@/services/FormService';
	import { VForm } from 'vuetify/components'
	import { LawFirmBot } from '@/interfaces/LawFirmBot';
	import { BotType } from '@/interfaces/BotType';
	import { GlobalAlertService } from '@/services/GlobalAlertService';
	import { ApiResponse } from '@/interfaces/ApiResponse';
	import { BaseService } from '@/services/BaseService';
	import { VersionsStore } from '@/Stores/VersionStore';

	interface Data extends IServerData, IEditable<LawFirmBot> {
		progress: boolean,
		rulesBotId: Array<(value: string) => {}>,
		rulesArea: Array<(value: IEntity[] | IEntity) => {}>,
		rulesBotType: Array<(value: IEntity[] | IEntity) => {}>,
	}

	const __default__ = defineComponent({
		props: {
			propEntity: {
				type: Object as PropType<LawFirmBot>,
				default: null,
			},
			propController: {
				type: String,
				default: null,
			},
			propAreas: {
				type: Object as PropType<IEntity[]>,
				default: null,
			},
			propBotTypes: {
				type: Object as PropType<BotType[]>,
				default: null,
			},
		},
		data(): Data {
			this.updateAlert();

			return {
				editableEntity: this.propEntity,
				controller: this.propController,
				progress: false,
				rulesBotId: [
					value => {
						if (/^\d+$/.test(value)) return true;

						return 'Bot Id must consist at least 1 digits.'
					},
				],
				rulesArea: [
					(value: IEntity | IEntity[]) => {
						if ((value as IEntity[])?.length || (value as IEntity)?.id) return true;

						return 'Area of law should be specified.'
					},
				],
				rulesBotType: [
					(value: IEntity | IEntity[]) => {
						if ((value as IEntity[])?.length || (value as IEntity)?.id) return true;

						return 'Bot type should be specified.'
					},
				],
			}
		},
		computed: {
		},
		watch: {
			propEntity(newValue, oldValue) {
				this.editableEntity = newValue;
			},
		},
		methods: {
			close() {
				this._close();
			},

			_close(entity?: LawFirmBot) {
				this.$emit("close-modal", entity);
			},

			updateAlert(alertType?: AlertType, message?: string) {
				GlobalAlertService.showAlert(alertType ? { type: alertType, message: message } as Alert : null);
			},

			trySave() {
				if (this.editableEntity?.botType?.id) {
					this.editableEntity.botTypeId = this.editableEntity?.botType.id;
				}
				if (this.editableEntity?.area?.id) {
					this.editableEntity.areaOfLawId = this.editableEntity?.area.id;
				}
				FormService.processIfValid(this.$refs.form as VForm, this.save, this.onError);
			},

			save() {
				this.updateAlert();
				this.progress = true;
				ApplicationService.updateEntity(this.editableEntity as LawFirmBot, this.controller, this.onError)
					.then(json => {
						const response = json as ApiResponse<LawFirmBot>;
						if (response.errorMessage) {
							throw response;
						}
						VersionsStore.increment(this.controller);
						this._close(this.editableEntity as LawFirmBot);
					})
					.catch(reason => BaseService.processError(reason, this.onError))
					.finally(() => {
						this.progress = false;
					});
			},

			onError(error: string) {
				this.updateAlert(AlertType.error, error);
			},
		},
	})


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'LawFirmBotForm',
  setup(__props) {

	
return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, null, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_1, _toDisplayString((_ctx.editableEntity.id > 0 ? 'Edit': 'New') + ' Firm bot'), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_text, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_container, null, {
            default: _withCtx(() => [
              _createVNode(_unref(VForm), {
                ref: "form",
                disabled: _ctx.progress
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            "hide-details": "",
                            variant: "outlined",
                            modelValue: _ctx.editableEntity.botId,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.editableEntity.botId) = $event)),
                            label: "Bot Id",
                            rules: _ctx.rulesBotId
                          }, null, 8, ["modelValue", "rules"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, null, {
                        default: _withCtx(() => [
                          _createVNode(FormCombobox, {
                            propItems: _ctx.propAreas,
                            propMultiple: false,
                            propSelectedItems: _ctx.editableEntity.area,
                            "onUpdate:propSelectedItems": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.editableEntity.area) = $event)),
                            propDisplayName: 'name',
                            propController: 'areaoflaw',
                            propTitle: 'Areas of law',
                            propRules: _ctx.rulesArea,
                            propDisabled: _ctx.progress
                          }, null, 8, ["propItems", "propSelectedItems", "propRules", "propDisabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, null, {
                        default: _withCtx(() => [
                          _createVNode(FormCombobox, {
                            propItems: _ctx.propBotTypes,
                            propMultiple: false,
                            propSelectedItems: _ctx.editableEntity.botType,
                            "onUpdate:propSelectedItems": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.editableEntity.botType) = $event)),
                            propDisplayName: 'name',
                            propController: 'bottype',
                            propTitle: 'Bot Type',
                            propRules: _ctx.rulesBotType,
                            propDisabled: _ctx.progress
                          }, null, 8, ["propItems", "propSelectedItems", "propRules", "propDisabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _withDirectives(_createVNode(_component_v_progress_linear, { indeterminate: "" }, null, 512), [
                    [_vShow, _ctx.progress]
                  ])
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_actions, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_spacer),
          _createVNode(_component_v_btn, {
            color: "indigo-darken-3",
            variant: "flat",
            disabled: _ctx.progress,
            onClick: _ctx.close
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Cancel ")
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]),
          _createVNode(_component_v_btn, {
            color: "indigo-darken-3",
            variant: "flat",
            disabled: _ctx.progress,
            onClick: _ctx.trySave
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Save ")
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})